/* eslint-disable indent */
import polyline from "google-polyline";
import { first, last } from "lodash/fp";
class Controller {
  constructor($mdDialog, GoogleMaps) {
    this.googleMapsUrl = GoogleMaps.getSource();
  }

  $onInit() {
    const getStringPosition = (mapOrigin) =>
      `${mapOrigin.loc.coordinates[1]},${mapOrigin.loc.coordinates[0]}`;
    this.stations = this.ride.stations_data.map((station) => {
      return station.station;
    });
    this.onMapInit = (map) => {
      this.map = map;
      this.fetchPolyline();
      this.showDetails = (event, point, markerId) => {
        this.currentPoint = point;
        this.map.showInfoWindow(event, "stationInfoWindow", markerId);
      };
    };

    const clonedHardStations = [...this.stations];
    this.center = `${
      (first(clonedHardStations).loc.coordinates[1] +
        last(clonedHardStations).loc.coordinates[1]) /
      2
    },
      ${
        (first(clonedHardStations).loc.coordinates[0] +
          last(clonedHardStations).loc.coordinates[0]) /
        2
      }`;
    const origin = getStringPosition(clonedHardStations.shift());
    const destination = getStringPosition(clonedHardStations.pop());
    const waypoints = clonedHardStations.map((hs) => {
      const location = {
        lat: hs.loc.coordinates[1],
        lng: hs.loc.coordinates[0],
      };
      return { location, stopover: false };
    });
    this.fetchPolyline = () => {
      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin,
          destination,
          // eslint-disable-next-line no-undef
          travelMode: window.google.maps.TravelMode.DRIVING,
          waypoints,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            this.polyline = polyline.decode(result.routes[0].overview_polyline);
          }
        }
      );
    };
  }
}
export default Controller;



// WEBPACK FOOTER //
// ./src/components/preLockedMap/preLockedMap.controller.js